import type { ActivityRecord, ActivityStats } from "@ti/core";
import { z } from "zod";

export const ACTIVITY_KINDS = ["action", "statement"] as const;
export const AUTHORITY_VERDICTS = ["within", "outside", "unknown"] as const;
export const ACTIVITY_STATUSES = ["completed", "pending", "failed", "blocked"] as const;

export const KIND_LABEL: Record<ActivityRecord["kind"], string> = { action: "Actions", statement: "Statements" };

export const AFFECTED_KIND_LABEL: Record<NonNullable<ActivityRecord["affected"]>["kind"], string> = {
  end_user: "End user",
  internal_user: "Internal user",
  customer: "Your organization",
  system: "System",
};

const ActivitySearchSchema = z.object({
  agent: z.string().min(1).optional().catch(undefined),
  kind: z.enum(ACTIVITY_KINDS).optional().catch(undefined),
  authority: z.enum(AUTHORITY_VERDICTS).optional().catch(undefined),
  status: z.enum(ACTIVITY_STATUSES).optional().catch(undefined),
  actionClass: z.string().min(1).optional().catch(undefined),
  pack: z.string().min(1).optional().catch(undefined),
  affectedId: z.string().min(1).optional().catch(undefined),
});
export type ActivitySearch = z.output<typeof ActivitySearchSchema>;
export const FILTER_KEYS = ["agent", "kind", "authority", "status", "actionClass", "pack", "affectedId"] as const satisfies ReadonlyArray<keyof ActivitySearch>;

export function parseActivitySearch(search: Record<string, unknown>): ActivitySearch {
  const r = ActivitySearchSchema.safeParse(search);
  if (!r.success) return {};
  return Object.fromEntries(Object.entries(r.data).filter(([, v]) => v !== undefined)) as ActivitySearch;
}

export const PAGE_SIZE = 50;

/** Series identity is fixed: within → SERIES[0], outside → SERIES[1], failed → SERIES[2]. */
export const DAILY_KEYS = ["within", "outside", "failed"] as const satisfies ReadonlyArray<keyof ActivityStats["daily"][number]>;
export type DailyKey = (typeof DAILY_KEYS)[number];
export const DAILY_LABEL: Record<DailyKey, string> = { within: "Within authority", outside: "Outside authority", failed: "Failed" };
